import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";

function Add_subAdmin() {
  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [select, setSelect] = useState("");
  const [password, setPassword] = useState("");
  const [ConfirmPassword, setConfPassword] = useState("");
  const [loginId, setLoginId] = useState("");
  const [phone, setPhone] = useState("");
  const [position, setPosition] = useState("");

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/editAddSubAdmin",
        {
          type: 1,
          name: name,
          email: email,
          mobile: phone,
          position: "SubAdmin",
          role: "SubAdmin",
          userid: loginId,
          password: password,
          ConfirmPassword: ConfirmPassword,
          username: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log('My_Team', responceRight?.data?.data)
      if (responceRight?.data?.data == "sub admin added successfully") {
        toast.success("SubAdmin Added Successfully");
        setTimeout(() => {
          navigate("/Manage_subadmin");
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^a-zA-Z]/g, "");
    setLoginId(filteredValue);
  };

  // useEffect(() => {}, []);
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div className="row">
            <div className="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a href="/Manage_subadmin">View All Sub Admin List</a>
                  </h4>
                </div>
                <div class="panel-body table-rep-plugin">
                  <div class="row">
                    <div class="box col-md-12">
                      <div class="box-inner">
                        <div class="box-content">
                          <div id="multi">
                            <div id="view1">
                              <form>
                                {" "}
                                <div class="form-horizontal">
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Name
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="name"
                                        onChange={(e) =>
                                          setName(e.target.value)
                                        }
                                        name="name"
                                        type="text"
                                        placeholder="Enter Name"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Email ID
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="email"
                                        name="email"
                                        onChange={(e) =>
                                          setEmail(e.target.value)
                                        }
                                        type="text"
                                        placeholder="Enter Email Id"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Mobile No.
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="phone"
                                        name="phone"
                                        onChange={(e) =>
                                          setPhone(e.target.value)
                                        }
                                        type="text"
                                        placeholder="Enter Mobile Number"
                                      />
                                    </div>
                                  </div>
                                  {/* <div class="form-group">
                                                                        <label class="col-sm-2 control-label text-left">Position</label>
                                                                        <div class="col-sm-5">
                                                                            <input
                                                                                class="form-control"
                                                                                id="position"
                                                                                name="position"
                                                                                onChange={(e) => setPosition(e.target.value)}
                                                                                type="text"
                                                                                placeholder="VRM-Matic"
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label class="col-sm-2 control-label text-left">Role</label>
                                                                        <div class="col-sm-5">
                                                                            <select class="form-control" onChange={(e) => setSelect(e.target.value)} id="role" name="role">
                                                                                <option value="">--Select Role--</option>
                                                                                <option value="Admin">Admin</option>
                                                                                <option selected="selected" value="Subadmin">
                                                                                    Subadmin
                                                                                </option>
                                                                            </select>

                                                                        </div>
                                                                    </div> */}
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Login Id
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="user_id"
                                        name="user_id"
                                        value={loginId}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Enter Login Id"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Password
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="pswd"
                                        onChange={(e) =>
                                          setPassword(e.target.value)
                                        }
                                        name="pswd"
                                        type="password"
                                        placeholder="Enter Password"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-2 control-label text-left">
                                      Confirm Password
                                    </label>
                                    <div class="col-sm-5">
                                      <input
                                        class="form-control"
                                        id="ConfirmPassword"
                                        onChange={(e) =>
                                          setConfPassword(e.target.value)
                                        }
                                        name="ConfirmPassword"
                                        type="password"
                                        placeholder="Enter Confirm Password"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-actions text-right">
                                    <input
                                      type="button"
                                      value="Submit"
                                      onClick={() => referral_API()}
                                      class="btn btn-primary"
                                    />
                                  </div>
                                </div>
                              </form>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_subAdmin;
